import React, { FunctionComponent } from "react";

import { ITextProps, noWrap, Stack, Text, useTheme } from "@bps/fluent-ui";
import { DisplayGuid } from "@components/DisplayGuid";
import { TabsNavLinkProps } from "@components/tabs-nav/TabNav.types";
import { useTenantQuery } from "@libs/api/gateways/plt/plt-gateway.hooks";

interface TenantTabHeaderProps extends Omit<TabsNavLinkProps, "closeTab"> {}
export const TenantTabHeader: FunctionComponent<TenantTabHeaderProps> = ({
  details
}) => {
  const theme = useTheme();
  const { data } = useTenantQuery(details.id);

  const inactiveStyle = data?.isInactive
    ? { background: theme.palette.red, undefined }
    : {};

  const headerTextStyles: ITextProps["styles"] = {
    root: {
      width: "100%",
      lineHeight: "normal",
      ...noWrap
    }
  };
  return (
    <Stack
      horizontalAlign="start"
      styles={{ root: { ...noWrap, textAlign: "left", ...inactiveStyle } }}
    >
      <Text variant="large" styles={headerTextStyles}>
        {details.name ?? data?.name}
      </Text>
      <DisplayGuid variant="xSmall" styles={headerTextStyles}>
        {details.id}
      </DisplayGuid>
    </Stack>
  );
};
